export class JoseError extends Error {
    static code = 'ERR_JOSE_GENERIC';
    code = 'ERR_JOSE_GENERIC';
    constructor(message?: string, options?: ErrorOptions) {
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}

export class JoseNotSupported extends JoseError {
    static override code = 'ERR_JOSE_NOT_SUPPORTED';
    override code = 'ERR_JOSE_NOT_SUPPORTED';
}

export class JwsInvalid extends JoseError {
    static override code = 'ERR_JWS_INVALID';
    override code = 'ERR_JWS_INVALID';
}

export class JwksInvalid extends JoseError {
    static override code = 'ERR_JWKS_INVALID';
    override code = 'ERR_JWKS_INVALID';
}

export class JwksNoMatchingKey extends JoseError {
    static override code = 'ERR_JWKS_NO_MATCHING_KEY';
    override code = 'ERR_JWKS_NO_MATCHING_KEY';
    constructor(
        message = 'No matching key found in the JSON Web Key Set',
        options?: ErrorOptions
    ) {
        super(message, options);
    }
}

export class JwksTimeout extends JoseError {
    static override code = 'ERR_JWKS_TIMEOUT';
    override code = 'ERR_JWKS_TIMEOUT';
    constructor(
        message = 'request timed out',
        options?: ErrorOptions
    ) {
        super(message, options);
    }
}
